// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wArb","rootMobile":"styles_rootMobile__20bBU"};